export enum TooltipPredefinedDescriptionKeys {
  APR,
  DEFERMENT_PERIOD,
  BASIC_REQUIREMENTS,
}
